import { render, staticRenderFns } from "./active-platform.part.vue?vue&type=template&id=61968d3e&"
import script from "./active-platform.part.vue?vue&type=script&lang=js&"
export * from "./active-platform.part.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports